import MagazinesModel, { MagazinesFilterType } from "../models/magazines.model";
import { MagazineType } from "../types/magazine";
import { useReducerAsState } from "./useReducerAsState";

interface State {
    magazines: Array<MagazineType>;
    totalMagazines: number;
    loadingMagazines: boolean;
    magazinesError: string;
    magazineCategories: Array<{id: number; name: string}>;
    magazine: MagazineType | null;
}

const useMagazines = () => {
    const [state, setState] = useReducerAsState<State>({
        magazines: [],
        totalMagazines: 0,
        loadingMagazines: false,
        magazinesError: "",
        magazineCategories: [],
        magazine: null
    });

    const { 
        magazines,
        totalMagazines,
        magazineCategories,
        magazine,
        loadingMagazines,
        magazinesError
    } = state

    const fetchMagazines = async (filters: MagazinesFilterType) => {
        setState({loadingMagazines: true})
        try {
            const response = await MagazinesModel.getAll(filters)
            if(response.error){
                setState({ magazines: [], totalMagazines: 0, loadingMagazines: false, magazinesError: response.error })
                return;
            }
            setState({ magazines: response.newspaper?.data, totalMagazines: response.newspaper?.total, loadingMagazines: false, magazinesError: "", })
        } catch (e){
            setState({loadingMagazines: false})
            console.error(`MAGZINES_ERROR: ${e}`)
        }
    }

    const fetchMagazineCategories = async () => {
        setState({magazineCategories: []})
        try {
            const response = await MagazinesModel.getCategories()
            if(response.error){
                setState({ magazineCategories: [] })
                return;
            }
            setState({ magazineCategories: response.magazine_categories })
        } catch (e){
            setState({magazineCategories: []})
            console.error(`MAGZINES_ERROR: ${e}`)
        }
    }

    const findMagazine = async (id: number) => {
        setState({loadingMagazines: true, magazinesError: ""})
        try {
            const response = await MagazinesModel.getMagazine(id)
            if(response.error){
                setState({loadingMagazines: false, magazinesError: response.error})
                return undefined;
            }

            setState({loadingMagazines: false, magazinesError: ""})
            return response.magazine;
        } catch (e: any){
            setState({loadingMagazines: false, magazinesError: e.toString()})
            console.error(`MAGZINES_ERROR: ${e}`)
            return undefined
        }
    }

    const createMagazine = async (data: any): Promise<string> => {
        try {
            const response = await MagazinesModel.createMagazine(data)
            if(response.error){
                return response.error;
            }
            return ""
        } catch (e: any){
            console.error(`MAGZINES_CREATE_ERROR: ${e}`)
            return e.toString()
        }
    }

    const updateMagazine = async (data: any): Promise<string> => {
        try {
            const response = await MagazinesModel.updateMagazine(data)
            if(response.error){
                return response.error;
            }
            return "";
        } catch (e:any){
            console.error(`MAGZINES_UPDATING_ERROR: ${e}`)
            return e
        }
    }

    const deleteMagazineAttachment = async (mId: number, fId: number) => {
        try {
            const response = await MagazinesModel.deleteAttachment({ magazineId: mId, fileId: fId });
            if(response?.error){
                return response.error;
            }
            return ""
        } catch(e){
            console.error(`MAGZINES_ATTCHAMENT_ERROR: ${e}`)
            return e
        }
    }

    const deleteMagazine = async (magazineId: number) => {
        try {
            const response = await MagazinesModel.deleteMagazine({ magazineId });
            if(response?.error){
                return undefined;
            }
            return true
        } catch(e){
            console.error(`MAGZINE_DELETE_ERROR: ${e}`)
            return false
        }
    }

    const triggerMagazineDownload = async () => {
        try {
            const response = await MagazinesModel.triggerMagazineDownload();
            return response
        } catch(e){
            console.error(`MAGZINE_DELETE_ERROR: ${e}`)
            return null
        }
    }

    return {
        magazines, magazine, totalMagazines, magazineCategories, fetchMagazines, fetchMagazineCategories, findMagazine,createMagazine, updateMagazine,
        deleteMagazineAttachment, deleteMagazine, loadingMagazines, magazinesError, triggerMagazineDownload
    }
}

export default useMagazines;